<template>
  <div class="wrapper_group_dashboard ">
    <div class="group_dashboard">
      <div class="wrapper-group-admin">
        <div class="container-fluid">
          <Breadcrumb :items="breadcrumbItems" />
          <h3>Group Administrator</h3>
          <div class="row justify-content-md-center">
            <div class="col-xxl-6 col-xl-6 col-lg-8 col-md-8">
              <div class="group-admin-card">
                <div class="group-admin-head text-center">
                  <div class="group-admin-head-content">
                    <h1>Group Administrator</h1>
                    <a
                      v-if="showAddBtn"
                      href="#"
                      title="Add group"
                      class="group-admin-btn"
                      @click.prevent="openAdminModal"
                    >
                      <i class="fas fa-plus"></i>
                    </a>
                  </div>
                  <p v-if="showAddBtn">
                    Group Admins are additional accounts that you can add, that will have access to
                    your dashboard.
                  </p>
                </div>
                <div class="group-admin-body">
                  <h3>User</h3>
                  <GroupAdminListContent :admins="userList" type="all" @adminDeleted="getAdminList" :showOtherBtns="showOtherBtns" />
                  <hr />
                  <h3>Pending users</h3>
                  <GroupAdminListContent type="pending" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Old Add Admin Modal -->
        <!-- <GroupAdminAdd
          ref="adminModal"
          :value="showAddAdminModal"
          @close="showAddAdminModal = false"
          @onGroupAdminAdded="getAdminList"
        /> -->

        <!-- New Add Admin Modal -->
        <GroupAdminAdd
          ref="adminModal"
          :value="showAddAdminModal"
          @onSuccess="getAdminList"
          @onCloseModal="showAddAdminModal = false"
          />
      </div>
    </div>
  </div>
</template>
<script>
  import Breadcrumb from '@/components/ui/Breadcrumb.vue';
  import GroupAdminListContent from '@/pages/GroupAdministrator/partials/GroupAdminListContent.vue';
  // import GroupAdminAdd from '@/pages/GroupAdministrator/modal/GroupAdminAdd.vue';  // Old modal import (contains the old modal design code that doesnt match with Rep & Member Dashboard)
  import GroupAdminAdd from "@/pages/GroupAdministrator/modal/GroupAdminAddNew.vue"; // New modal import (contains the new modal design code that matches with Rep & Member Dashboard)
  import Api from "@/resource/Api";

  export default {
    name: 'GroupAdminList',
    components: {
      Breadcrumb,
      GroupAdminListContent,
      GroupAdminAdd
    },
    data() {
      return {
        showAddAdminModal: false,
        breadcrumbItems: [
          {
            title: 'Group Dashboard',
            path: { name: 'GroupDashboard' },
          },
          {
            title: 'Group Administrator',
            active: true,
          },
        ],
        userList: [],
        pendingUserList: [],
        showAddBtn: false,
        showOtherBtns: false,
      };
    },
    mounted() {
      this.getAdminList();
    },
    methods: {
      openAdminModal() {
        this.$refs.adminModal.showModal();
      },
      getAdminList() {
        let loader = this.$loading.show();
        const url = "get-groups-admin-details"
        Api.get(url)
          .then((response) => {
            if (response.data.status == "success") {
              this.showAddBtn = response.data.data.show_add_user_button==1 ? true : false;
              this.showOtherBtns = response.data.data.show_other_buttons==1 ? true : false;
              this.userList = response.data.data.user_list;
              this.pendingUserList = response.data.data.pending_user_list;
            }
          })
          .catch(() => {
            this.showAddBtn = false;
            this.showOtherBtns = false;
            this.userList = [];
            this.pendingUserList = [];
          })
          .finally(() => {
            loader.hide();
          });
      },
    },
  };
</script>
<style>
  .wrapper-group-admin {
    width: 100%;
    padding: 0px 15px;
  }
  .wrapper-group-admin h3 {
    font-size: 22px;
    color: #2c3f58;
    font-weight: 700;
    margin-bottom: 0;
  }
  .group-admin-card {
    background: #fff;
    box-shadow: 0 2px 15px rgb(216 227 235 / 33%);
    border-radius: 10px;
    padding: 2rem;
    margin-top: 2rem;
  }
  .group-admin-head h1 {
    font-size: 22px;
    font-weight: 700;
    color: #2c3f58;
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 0px;
    margin-right: 10px;
  }
  .group-admin-head p {
    color: #778699;
    font-size: 14px;
    margin-top: 1rem;
  }
  .group-admin-head-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .group-admin-btn,
  .group-admin-btn:hover {
    background: #3bb54a;
    color: #fff;
    border: 0;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 1.5rem;
    aspect-ratio: 1/1;
  }
  .group-admin-body h3 {
    font-size: 16px;
    font-weight: 700;
    color: #2c3f58;
  }
  .group-admin-body hr {
    background: #969696;
    opacity: 25%;
    margin: 2rem 0;
  }
  .group-admin-body ul li {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px !important;
    font-weight: 400 !important;
    padding: 10px 15px;
    font-size: 15px;
    margin: 10px 0;
    border-radius: 8px;
    word-break: break-word;
  }
  .group-admin-body ul li:nth-child(odd) {
    background: rgb(41 188 255 / 10%);
  }
  .group-admin-body ul li:nth-child(even) {
    background: #fafbfd;
  }
  .grp-admin-action {
    display: flex;
    align-items: center;
    color: #fff;
  }
  .deleteEmail,
  .ccEmail,
  .suspend-btn,
  .deleteEmail:hover {
    background: #ea584e;
    color: #fff;
    display: inline-block;
    border-radius: 6px;
    font-size: 12px;
    padding: 6px 10px;
    margin-left: 10px;
    text-decoration: none;
  }
  .ccEmail:hover {
    background-color: red;
  }
  .suspend-btn,
  .suspend-btn:hover {
    background: #f29423;
    padding: 6px 10px;
    text-decoration: none;
    color: #fff;
  }
  .activate-btn,
  .activate-btn:hover {
    background: green;
    color: #fff;
    display: inline-block;
    border-radius: 6px;
    font-size: 12px;
    padding: 6px 10px;
    margin-left: 10px;
    text-decoration: none;
  }
  .activate-btn a,
  .suspend-btn a,
  .activate-btn a:hover,
  .suspend-btn a:hover {
    color: #fff;
  }
  @media (max-width: 576px) {
    .ccEmail,
    .deleteEmail,
    .activate-btn,
    .suspend-btn {
      padding: 10px 15px;
    }
    .activate-btn,
    .suspend-btn {
      margin-left: 0rem;
    }
    .group-admin-body ul li {
      flex-direction: column;
      align-items: baseline;
      gap: 0.5rem;
      padding-bottom: 1rem;
    }
  }
</style>
